<template>
  <div v-if="display" class="modal" id="eventTutorialModal"
    aria-hidden="true"
    tabindex="-1"
    aria-labelledby="eventTutorialModalLabel">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-size">
        <div class="modal-header">
          <button type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close">
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div align="center">
                  <div id="eventTutorial" class="carousel slide" data-bs-ride="carousels">
                    <div class="carousel-indicators indicator-events">
                      <button type="button"
                        data-bs-target="#eventTutorial"
                        data-bs-slide-to="0"
                        aria-current="true"
                        aria-label=""
                        class="active">
                      </button>
                      <button type="button"
                        data-bs-target="#eventTutorial"
                        data-bs-slide-to="1"
                        aria-label="">
                      </button>
                      <button type="button"
                        data-bs-target="#eventTutorial"
                        data-bs-slide-to="2"
                        aria-label="">
                      </button>
                      <button type="button"
                        data-bs-target="#eventTutorial"
                        data-bs-slide-to="3"
                        aria-label="">
                      </button>
                    </div>
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <img src="/rekognition.png" />
                        <h4 class="mt-10">
                          {{$t("events.tutorial.first.title")}}
                        </h4>
                        <p>
                          {{$t("events.tutorial.first.description")}}
                        </p>
                      </div>
                      <div class="carousel-item">
                        <img src="../../images/buttons/add.png" />
                        <h4 class="mt-10">
                          {{$t("events.tutorial.second.title")}}
                        </h4>
                        <p>
                          {{$t("events.tutorial.second.description")}}
                        </p>
                      </div>
                      <div class="carousel-item">
                        <img src="../../images/heart.png" />
                        <h4 class="mt-10">
                          {{$t("events.tutorial.third.title")}}
                        </h4>
                        <p>
                          {{$t("events.tutorial.third.description")}}
                        </p>
                      </div>
                      <div class="carousel-item">
                        <img src="../../images/account.png" />
                        <h4 class="mt-10">
                          {{$t("events.tutorial.fourth.title")}}
                        </h4>
                        <p class="mb-20">
                          {{$t("events.tutorial.fourth.description")}}
                        </p>
                        <button type="submit" class="button-modal primary-btn" style="width: 200px">
                          {{$t("auth.signUp.create")}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

export default {
  name: "Event.Tutorial",
  data() {
    return {
      display: true
    }
  },
  mounted() {
    this.display = this.displayEventTutorial
    if(this.display) {
      var modal = new bootstrap.Modal(document.getElementById('eventTutorialModal'), {})
      modal.show()
    }
  },
  methods: {
    ...mapActions("Web", ["hideEventTutorial"]),
    close() {
      this.hideEventTutorial()
      this.display = false
    }
  },
  computed: {
    ...mapGetters("Web", ["displayEventTutorial"])
  }
}
</script>

<style lang="scss" scoped>
  @import '../../scss/variables.scss';

  .modal-size {
    border-radius: 20px;
    background: $secondary-base!important;
    color: $primary-base;
    width: 400px;
    height: 430px;
    margin: auto;
  }

  .button-modal{
    margin-top: -20px !important;
  }

  .indicator-events {
    position: relative;
    right: 0;
    bottom: -300px;
    left: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%;
    list-style: none;

    .active {
      opacity: 1;
      background-color: white !important;
      border: 2px solid grey !important;
    }
  }

  @media (max-width: 767px) {
    .modal-size{
      width: 100%;
      height: 450px;
    }

    .indicator-events {
      bottom: -340px;
    }
  }
</style>
